// extracted by mini-css-extract-plugin
export default {"container":"rLIBR","title":"uBJAg","content":"oi7W4"};